<template>
  <div class="logout"></div>
</template>

<script>
import { useUserServiceInject } from "@/context";

export default {
  name: "Logout",
  setup(props, { root }) {
    const { destroyToken } = useUserServiceInject();
    destroyToken();
  },
  created() {
    this.$store.dispatch("userLogout").then(() => {
      this.$router.push({ name: "tutorials" });
      // location.reload();
    });
  },
};
</script>
